export const validationPatterns = {
  usernameRegExp: new RegExp(/^[a-zA-Z0-9]*$/),
  lastNameRegExp: new RegExp(/^[a-zA-Z ,.'-]+$/),
  whitespaceRegExp: new RegExp(/^\S*$/),
};
